import React, { useEffect, useState } from "react";
import { Accordion, Button, Spinner } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { setLogout } from "../../Feature/Login/LoginSlice";
import {
  setActiveKey,
  setActiveMenu,
  setFinancialYear,
  setNewActiveKey,
  fetchFinancialYears,
} from "../../Feature/Sidebar/ActiveKeySlice";
import { setLabelDate, setLabelMonth } from "../../Feature/Graph/label";
import PCMC from "../../Assets/PCMC-LOGO.png";

const Sidebar = () => {
  const userState = useSelector((state) => state.loginData.userData);
  const activeKeyRedux = useSelector((state) => state.activeData.activeNumberKey);
  const financialYear = useSelector((state) => state.activeData.financialYear);
  const [parentAccKey, setParentAcckey] = useState(null);
  const activeMenu = useSelector((state) => state.activeData?.activeMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchFinancialYears());
  }, []);

  useEffect(() => {
    const path = location.pathname;
    const usertype = userState?.usertype_keyname[0];

    const adminPathMapping = {
      "/dashboard": { activeKey: 0, subActiveKey: 0, activeTab: "Home" },
      "/dashboard/analytics": { activeKey: 0, subActiveKey: 0, activeTab: "Home" },
      "/dashboard/new-home": { activeKey: 1, subActiveKey: 1, activeTab: "Bill Distribution" },
      "/dashboard/bill-distribution": { activeKey: 1, subActiveKey: 1, activeTab: "Bill Distribution" },
      "/dashboard/manage-roles": { activeKey: 2, subActiveKey: 2, activeTab: "Manage Roles" },
      "/dashboard/palika-users": { activeKey: 45, subActiveKey: 0, activeTab: "Palika User Wise Bill Watap Report" },
      "/dashboard/new-contractors": { activeKey: 3, subActiveKey: 3, activeTab: "Mahila Wise Bill Watap Report" },
      "/dashboard/contractors": { activeKey: 3, subActiveKey: 3, activeTab: "Mahila Wise Bill Watap Report" },
      "/dashboard/distribution": { activeKey: 4, subActiveKey: 4, activeTab: "Distribution Report" },
      "/dashboard/zonewise-bill-analysis": { activeKey: 5, subActiveKey: 5, activeTab: "Zonewise Bill Analysis" },
      "/dashboard/new-bill-analysis": { activeKey: 5, subActiveKey: 5, activeTab: "Zonewise Bill Analysis" },
      "/dashboard/call-summary": { activeKey: 6, subActiveKey: 6.1, activeTab: "Call Summary" },
      "/dashboard/call-logs": { activeKey: 6, subActiveKey: 6.2, activeTab: "Call Logs" },
      "/dashboard/dialed-call-logs": { activeKey: 6, subActiveKey: 6.3, activeTab: "Dialed Call Logs" },
      "/dashboard/total-calling": { activeKey: 6, subActiveKey: 6.5, activeTab: "Total Call Summary" },
      "/dashboard/japti-notice": { activeKey: 7, subActiveKey: 7.1, activeTab: "Japti Notice" },
      "/dashboard/japti-karvai": { activeKey: 7, subActiveKey: 7.2, activeTab: "Japti Karvai" },
      "/dashboard/japti-mukti": { activeKey: 7, subActiveKey: 7.3, activeTab: "Japti Mukti" },
      "/dashboard/japti-karvai-zone-report": { activeKey: 7, subActiveKey: 7.4, activeTab: "Japti Karvai Zone Report" },
      "/dashboard/new-visit-reports": { activeKey: 11, subActiveKey: 11, activeTab: "Property Visit Report" },
      "/dashboard/staff-visit-reports": { activeKey: 1122, subActiveKey: 1122, activeTab: "Staff Visit Report" },
      "/dashboard/gatwise-bill-analysis": { activeKey: 18, subActiveKey: 18, activeTab: "Gatwise Bill Analysis" },
      "/dashboard/update-mobile": { activeKey: 180, subActiveKey: 180, activeTab: "Update Mobile" },
      "/dashboard/deleted-bill-history": { activeKey: 19, subActiveKey: 19.1, activeTab: "Deleted Bill History" },
      "/dashboard/bill-report": { activeKey: 19, subActiveKey: 19.2, activeTab: "Bill Report" },
      "/dashboard/new-japti-notice": { activeKey: 19, subActiveKey: 19.3, activeTab: "New Japti Notice" },
      "/dashboard/new-property-found": { activeKey: 34, subActiveKey: 34, activeTab: "New Property Found" },
      "/dashboard/imageverification": { activeKey: 44, subActiveKey: 44.1, activeTab: "Image Verification" },
      "/dashboard/rejected": { activeKey: 44, subActiveKey: 44.2, activeTab: "Image Verification History" },
      "/dashboard/surveyverification": { activeKey: 44, subActiveKey: 44.3, activeTab: "Survey Verification" },
      "/dashboard/surveyrejected": { activeKey: 44, subActiveKey: 44.4, activeTab: "Survey Verification History" },
      "/dashboard/rejected-list": { activeKey: 20, subActiveKey: 20, activeTab: "Rejected Bills" },
      "/dashboard/sms-sent-report": { activeKey: 8, subActiveKey: 8, activeTab: "SMS Sent Report" },
      "/dashboard/sms-details": { activeKey: 9, subActiveKey: 9, activeTab: "SMS Details" },
    };

    const zonalPathMapping = {
      "/dashboard/new-home": { activeKey: 10, subActiveKey: 10, activeTab: "Bill Distribution" },
      "/dashboard/bill-distribution": { activeKey: 10, subActiveKey: 10, activeTab: "Bill Distribution" },
      "/dashboard/new-visit-reports": { activeKey: 11, subActiveKey: 11, activeTab: "Property Visit Report" },
      "/dashboard/staff-visit-reports": { activeKey: 112, subActiveKey: 112, activeTab: "Staff Visit Report" },
      "/dashboard/new-contractors": { activeKey: 12, subActiveKey: 12, activeTab: "Mahila Wise Bill Watap Report" },
      "/dashboard/contractors": { activeKey: 12, subActiveKey: 12, activeTab: "Mahila Wise Bill Watap Report" },
      "/dashboard/zonal-contractors": { activeKey: 12, subActiveKey: 12, activeTab: "Mahila Wise Bill Watap Report" },
      "/dashboard/new-bill-analysis": { activeKey: 13, subActiveKey: 13, activeTab: "Zone Wise Bill Analysis" },
      "/dashboard/zonewise-bill-analysis": { activeKey: 13, subActiveKey: 13, activeTab: "Zone Wise Bill Analysis" },
      "/dashboard/gatlipik-report-analysis": { activeKey: 113, subActiveKey: 113, activeTab: "Gat Lipik Analysis" },
      "/dashboard/gatwise-bill-analysis": { activeKey: 18, subActiveKey: 18, activeTab: "Gatwise Bill Analysis" },
      "/dashboard/zonal-call-summary": { activeKey: 311, subActiveKey: 311.1, activeTab: "Call Summary" },
      "/dashboard/zonal-call-logs": { activeKey: 311, subActiveKey: 311.2, activeTab: "Call Logs" },
      "/dashboard/zonal-dialed-call-logs": { activeKey: 311, subActiveKey: 311.3, activeTab: "Dialed Call Logs" },
      "/dashboard/zonal-total-calling": { activeKey: 311, subActiveKey: 311.5, activeTab: "Total Call Summary" },
      "/dashboard/zonal-japti-notice": { activeKey: 16, subActiveKey: 16, activeTab: "Japti Notice" },
      "/dashboard/zonal-japti-karvai": { activeKey: 22, subActiveKey: 22, activeTab: "Japti Karvai" },
      "/dashboard/zonal-japti-mukti": { activeKey: 23, subActiveKey: 23, activeTab: "Japti Mukti" },
      "/dashboard/bill-report": { activeKey: 15, subActiveKey: 15.1, activeTab: "Bill Report" },
      "/dashboard/deleted-bill-history": { activeKey: 15, subActiveKey: 15.2, activeTab: "Deleted Bill History" },
      "/dashboard/imageverification": { activeKey: 19, subActiveKey: 19.1, activeTab: "Image Verification" },
      "/dashboard/rejected": { activeKey: 19, subActiveKey: 19.2, activeTab: "Image Verification History" },
      "/dashboard/surveyverification": { activeKey: 19, subActiveKey: 19.3, activeTab: "Survey Verification" },
      "/dashboard/surveyrejected": { activeKey: 19, subActiveKey: 19.4, activeTab: "Survey Verification History" },
      "/dashboard/palika-users": { activeKey: 20, subActiveKey: 20, activeTab: "Palika User Wise Bill Watap Report" },
    };

    const gatLipikPathMapping = {
      "/dashboard/new-gat-home": { activeKey: 51, subActiveKey: 51, activeTab: "Bill Distribution" },
      "/dashboard/bill-distribution": { activeKey: 51, subActiveKey: 51, activeTab: "Bill Distribution" },
      "/dashboard/contractors": { activeKey: 53, subActiveKey: 53, activeTab: "Mahila Wise Bill Watap Report" },
      "/dashboard/gat-property-report": { activeKey: 52, subActiveKey: 52, activeTab: "Property Visit Report" },
      "/dashboard/gat-mahila-report": { activeKey: 53, subActiveKey: 53, activeTab: "Mahila Wise Bill Watap Report" },
      "/dashboard/gat-wise-bill-analysis": { activeKey: 54, subActiveKey: 54, activeTab: "Gatwise Bill Analysis" },
      "/dashboard/zonewise-bill-analysis": { activeKey: 54, subActiveKey: 54, activeTab: "Gatwise Bill Analysis" },
      "/dashboard/gat-call-summary": { activeKey: 312, subActiveKey: 312.1, activeTab: "Call Summary" },
      "/dashboard/gat-call-logs": { activeKey: 312, subActiveKey: 312.2, activeTab: "Call Logs" },
      "/dashboard/gat-dialed-call-logs": { activeKey: 312, subActiveKey: 312.3, activeTab: "Dialed Call Logs" },
      "/dashboard/gat-total-calling": { activeKey: 312, subActiveKey: 312.5, activeTab: "Total Call Summary" },
      "/dashboard/gat-japti-notice": { activeKey: 55, subActiveKey: 55, activeTab: "Japti Notice" },
      "/dashboard/gat-japti-karwai": { activeKey: 59, subActiveKey: 59, activeTab: "Japti Karwai" },
      "/dashboard/gat-japti-mukti": { activeKey: 60, subActiveKey: 60, activeTab: "Japti Mukti" },
      "/dashboard/gat-bill-report": { activeKey: 56, subActiveKey: 56.1, activeTab: "Bill Report" },
      "/dashboard/gat-deleted-bill-history": { activeKey: 56, subActiveKey: 56.2, activeTab: "Deleted Bill History" },
      "/dashboard/imageverification": { activeKey: 57, subActiveKey: 57.1, activeTab: "Image Verification" },
      "/dashboard/rejected": { activeKey: 57, subActiveKey: 57.2, activeTab: "Image Verification History" },
      "/dashboard/surveyverification": { activeKey: 57, subActiveKey: 57.3, activeTab: "Survey Verification" },
      "/dashboard/surveyrejected": { activeKey: 57, subActiveKey: 57.4, activeTab: "Survey Verification History" },
      "/dashboard/palika-users": { activeKey: 58, subActiveKey: 58, activeTab: "Palika User Wise Bill Watap Report" },
    };

    const mavimPathMapping = {
      "/dashboard/new-home": { activeKey: 10, subActiveKey: 10, activeTab: "Bill Distribution" },
      "/dashboard/bill-distribution": { activeKey: 10, subActiveKey: 10, activeTab: "Bill Distribution" },
      "/dashboard/contractors": { activeKey: 12, subActiveKey: 12, activeTab: "Mahila Wise Bill Watap Report" },
      "/dashboard/new-visit-reports": { activeKey: 11, subActiveKey: 11, activeTab: "Property Visit Report" },
      "/dashboard/new-contractors": { activeKey: 12, subActiveKey: 12, activeTab: "Mahila Wise Bill Watap Report" },
      "/dashboard/new-bill-analysis": { activeKey: 13, subActiveKey: 13, activeTab: "Zone Wise Bill Analysis" },
      "/dashboard/zonewise-bill-analysis": { activeKey: 13, subActiveKey: 13, activeTab: "Zone Wise Bill Analysis" },
      "/dashboard/bill-report": { activeKey: 15, subActiveKey: 15.1, activeTab: "Bill Report" },
      "/dashboard/deleted-bill-history": { activeKey: 15, subActiveKey: 15.2, activeTab: "Deleted Bill History" },
      "/dashboard/rejected-list": { activeKey: 17, subActiveKey: 17, activeTab: "Rejected Bills" },
    };

    // sakshama same as mavim
    const sakshamaPathMapping = { ...mavimPathMapping };

    let pathMapping = adminPathMapping;
    if (usertype === "zonalofficer") pathMapping = zonalPathMapping;
    else if (usertype === "gatlipik") pathMapping = gatLipikPathMapping;
    else if (usertype === "mavim") pathMapping = mavimPathMapping;
    else if (usertype === "sakshama") pathMapping = sakshamaPathMapping;

    const matchedPath = pathMapping[path];
    if (matchedPath) {
      dispatch(setActiveKey(matchedPath));
    }
  }, [location.pathname, dispatch, userState?.usertype_keyname]);

  useEffect(() => {
    const usertype = userState?.usertype_keyname[0];

    if (usertype === "admin" || usertype === "internalDev") {
      const routes = {
        3: financialYear === "2023-2024" ? "/dashboard/contractors" : "/dashboard/new-contractors",
        1: financialYear === "2023-2024" ? "/dashboard/bill-distribution" : "/dashboard/new-home",
        5: financialYear === "2023-2024" ? "/dashboard/zonewise-bill-analysis" : "/dashboard/new-bill-analysis",
      };
      const route = routes[activeKeyRedux?.activeKey];
      if (route) navigate(route);
    }

    if (usertype === "zonalofficer") {
      const routes = {
        10: financialYear === "2023-2024" ? "/dashboard/bill-distribution" : "/dashboard/new-home",
        12: financialYear === "2023-2024" ? "/dashboard/contractors" : "/dashboard/new-contractors",
        13: financialYear === "2023-2024" ? "/dashboard/zonewise-bill-analysis" : "/dashboard/new-bill-analysis",
      };
      const route = routes[activeKeyRedux?.activeKey];
      if (route) navigate(route);
    }

    if (usertype === "mavim" || usertype === "sakshama") {
      const routes = {
        10: financialYear === "2023-2024" ? "/dashboard/bill-distribution" : "/dashboard/new-home",
        12: financialYear === "2023-2024" ? "/dashboard/contractors" : "/dashboard/new-contractors",
        13: financialYear === "2023-2024" ? "/dashboard/zonewise-bill-analysis" : "/dashboard/new-bill-analysis",
      };
      const route = routes[activeKeyRedux?.activeKey];
      if (route) navigate(route);
    }

    if (usertype === "gatlipik") {
      const routes = {
        51: financialYear === "2023-2024" ? "/dashboard/bill-distribution" : "/dashboard/new-gat-home",
        53: financialYear === "2023-2024" ? "/dashboard/contractors" : "/dashboard/gat-mahila-report",
        54: financialYear === "2023-2024" ? "/dashboard/zonewise-bill-analysis" : "/dashboard/gat-wise-bill-analysis",
      };
      const route = routes[activeKeyRedux?.activeKey];
      if (route) navigate(route);
    }

  }, [financialYear, activeKeyRedux?.activeKey, userState?.usertype_keyname]);

  const handleLogout = () => {
    setLoader(true);
    dispatch(setLogout(null));
    dispatch(setActiveKey(0));
    dispatch(setLabelDate(""));
    dispatch(setLabelMonth(""));
    navigate("/");
    setLoader(false);
  };

  const handleAccordionChange = (activeKey, subActiveKey, tabName) => {
    dispatch(setActiveKey({ activeKey, subActiveKey, activeTab: tabName }));
  };

  const handleMenuChange = (activeKey, tabName, event) => {
    dispatch(setActiveMenu({ activeKey, activeTab: tabName }));
    if (activeKey === 0) event.stopPropagation();
  };

  return (
    <>
      <div className="sidenav-lg d-flex justify-content-between flex-column">
        <div>
          <div className="logoBg mb-4">
            <img src={PCMC} alt="PCMC Survey" width={70} />
          </div>

          <div className="menus">

            {/* ===================== ADMIN / INTERNAL DEV ===================== */}
            {userState?.usertype_keyname[0] === "admin" ||
              userState?.usertype_keyname[0] === "internalDev" ? (
              <>
                <Accordion flush>
                  <Accordion.Item>
                    <Accordion.Body style={{ padding: 0 }}>
                      <Accordion flush defaultActiveKey={activeKeyRedux?.activeKey}>

                        {financialYear === "2023-2024" && (
                          <Accordion.Item eventKey="0" className={activeKeyRedux?.activeKey === 0 ? "activeMenu" : ""}>
                            <Accordion.Header onClick={() => { handleAccordionChange(0, 0, "Home"); navigate("/dashboard"); }}>
                              {activeKeyRedux?.activeKey === 0 ? <Icon.HouseDoorFill className="me-2" /> : <Icon.HouseDoor className="me-2 icon" />}
                              Home
                            </Accordion.Header>
                          </Accordion.Item>
                        )}

                        <Accordion.Item eventKey="1" className={activeKeyRedux?.activeKey === 1 ? "activeMenu" : ""}>
                          <Accordion.Header onClick={() => {
                            handleAccordionChange(1, 1, "Bill Distribution");
                            navigate(financialYear === "2023-2024" ? "/dashboard/bill-distribution" : "/dashboard/new-home");
                          }}>
                            {activeKeyRedux?.activeKey === 1 ? <Icon.HouseDoorFill className="me-2" /> : <Icon.HouseDoor className="me-2 icon" />}
                            Bill Distribution
                          </Accordion.Header>
                        </Accordion.Item>

                        <Accordion.Item eventKey="2" className={activeKeyRedux?.activeKey === 2 ? "activeMenu" : ""}>
                          <Accordion.Header onClick={() => { handleAccordionChange(2, 2, "Manage Roles"); navigate("/dashboard/manage-roles"); }}>
                            {activeKeyRedux?.activeKey === 2 ? <Icon.PersonFillGear className="me-2" /> : <Icon.PersonGear className="me-2 icon" />}
                            Manage Users
                          </Accordion.Header>
                        </Accordion.Item>

                        {financialYear !== "2023-2024" && (
                          <Accordion.Item eventKey="11" className={activeKeyRedux?.activeKey === 11 ? "activeMenu" : ""}>
                            <Accordion.Header onClick={() => { handleAccordionChange(11, 11, "Property Visit Report"); navigate("/dashboard/new-visit-reports"); }}>
                              {activeKeyRedux?.activeKey === 11 ? <Icon.PeopleFill className="me-2" /> : <Icon.People className="me-2 icon" />}
                              Property Visit Report
                            </Accordion.Header>
                          </Accordion.Item>
                        )}

                        {financialYear !== "2023-2024" && financialYear !== "2024-2025" && (
                          <Accordion.Item eventKey={1122} className={activeKeyRedux?.activeKey === 1122 ? "activeMenu" : ""}>
                            <Accordion.Header onClick={() => { handleAccordionChange(1122, 1122, "Staff Visit Report"); navigate("/dashboard/staff-visit-reports"); }}>
                              {activeKeyRedux?.activeKey === 1122 ? <Icon.PeopleFill className="me-2" /> : <Icon.People className="me-2 icon" />}
                              Staff Visit Report
                            </Accordion.Header>
                          </Accordion.Item>
                        )}

                        <Accordion.Item eventKey="3" className={activeKeyRedux?.activeKey === 3 ? "activeMenu" : ""}>
                          <Accordion.Header onClick={() => {
                            handleAccordionChange(3, 3, "Mahila Wise Bill Watap Report");
                            navigate(financialYear === "2023-2024" ? "/dashboard/contractors" : "/dashboard/new-contractors");
                          }}>
                            {activeKeyRedux?.activeKey === 3 ? <Icon.PeopleFill className="me-2" /> : <Icon.People className="me-2 icon" />}
                            Mahila Wise Bill Watap Report
                          </Accordion.Header>
                        </Accordion.Item>

                        {financialYear === "2023-2024" && (
                          <Accordion.Item eventKey="4" className={activeKeyRedux?.activeKey === 4 ? "activeMenu" : ""}>
                            <Accordion.Header onClick={() => { handleAccordionChange(4, 4, "Distribution"); navigate("/dashboard/distribution"); }}>
                              {activeKeyRedux?.activeKey === 4 ? <Icon.BarChartFill className="me-2" /> : <Icon.BarChart className="me-2 icon" />}
                              Distribution Report
                            </Accordion.Header>
                          </Accordion.Item>
                        )}

                        <Accordion.Item eventKey="5" className={activeKeyRedux?.activeKey === 5 ? "activeMenu" : ""}>
                          <Accordion.Header onClick={() => {
                            handleAccordionChange(5, 5, "Zonewise Bill Analysis");
                            navigate(financialYear === "2023-2024" ? "/dashboard/zonewise-bill-analysis" : "/dashboard/new-bill-analysis");
                          }}>
                            {activeKeyRedux?.activeKey === 5 ? <Icon.ReceiptCutoff className="me-2" /> : <Icon.Receipt className="me-2 icon" />}
                            Zonewise Bill Analysis
                          </Accordion.Header>
                        </Accordion.Item>

                        {financialYear !== "2023-2024" && (
                          <Accordion.Item eventKey="18" className={activeKeyRedux?.activeKey === 18 ? "activeMenu" : ""}>
                            <Accordion.Header onClick={() => { handleAccordionChange(18, 18, "Gatwise Bill Analysis"); navigate("/dashboard/gatwise-bill-analysis"); }}>
                              {activeKeyRedux?.activeKey === 18 ? <Icon.Receipt className="me-2" /> : <Icon.Receipt className="me-2 icon" />}
                              Gatwise Bill Analysis
                            </Accordion.Header>
                          </Accordion.Item>
                        )}

                        {financialYear === "2026-2027" && (
                          <Accordion.Item eventKey="34" className={activeKeyRedux?.activeKey === 34 ? "activeMenu" : ""}>
                            <Accordion.Header onClick={() => { handleAccordionChange(34, 34, "New Property Found"); navigate("/dashboard/new-property-found"); }}>
                              {activeKeyRedux?.activeKey === 34 ? <Icon.Receipt className="me-2" /> : <Icon.Receipt className="me-2 icon" />}
                              New Property Found
                            </Accordion.Header>
                          </Accordion.Item>
                        )}

                        {/* Telecalling */}
                        <Accordion.Item eventKey={6} className={activeKeyRedux.activeKey === 6 ? "activeMenu dropDown" : "dropDown"}>
                          <Accordion.Header onClick={() => { handleAccordionChange(6, activeKeyRedux.subActiveKey, activeKeyRedux.activeTab); }}>
                            {activeKeyRedux?.activeKey === 6 ? <Icon.PeopleFill className="me-2" /> : <Icon.People className="me-2 icon" />}
                            Manage Telecalling
                          </Accordion.Header>
                          <Accordion.Body className="d-flex flex-column">
                            <Button onClick={() => { navigate("/dashboard/call-summary"); handleAccordionChange(6, 6.1, "Call Summary"); }} className={activeKeyRedux?.subActiveKey === 6.1 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                              {activeKeyRedux?.subActiveKey === 6.1 ? <Icon.ChatTextFill className="me-2" /> : <Icon.ChatText className="me-2 icon" />} Calling Summary
                            </Button>
                            <Button onClick={() => { navigate("/dashboard/call-logs"); handleAccordionChange(6, 6.2, "Call Logs"); }} className={activeKeyRedux?.subActiveKey === 6.2 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                              {activeKeyRedux?.subActiveKey === 6.2 ? <Icon.TelephoneForwardFill className="me-2" /> : <Icon.TelephoneForward className="me-2 icon" />} Call Logs
                            </Button>
                            <Button onClick={() => { navigate("/dashboard/dialed-call-logs"); handleAccordionChange(6, 6.3, "Dialed Call Logs"); }} className={activeKeyRedux?.subActiveKey === 6.3 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                              {activeKeyRedux?.subActiveKey === 6.3 ? <Icon.TelephoneForwardFill className="me-2" /> : <Icon.TelephoneForward className="me-2 icon" />} Dialed Call Logs
                            </Button>
                            <Button onClick={() => { handleAccordionChange(6, 6.5, "Total Call Summary"); navigate("/dashboard/total-calling"); }} className={activeKeyRedux?.subActiveKey === 6.5 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                              {activeKeyRedux?.subActiveKey === 6.5 ? <Icon.TelephonePlusFill className="me-2" /> : <Icon.TelephonePlus className="me-2 icon" />} Total Call Summary
                            </Button>
                          </Accordion.Body>
                        </Accordion.Item>

                        {/* Japti */}
                        <Accordion.Item eventKey="7" className={activeKeyRedux.activeKey === 7 ? "activeMenu dropDown" : "dropDown"}>
                          <Accordion.Header onClick={() => { handleAccordionChange(7, activeKeyRedux.subActiveKey, activeKeyRedux.activeTab); }}>
                            {activeKeyRedux?.activeKey === 7 ? <Icon.Coin className="me-2" /> : <Icon.Coin className="me-2 icon" />}
                            Japti Details
                          </Accordion.Header>
                          <Accordion.Body className="d-flex flex-column">
                            <Button onClick={() => { navigate("/dashboard/japti-notice"); handleAccordionChange(7, 7.1, "Japti Notice"); }} className={activeKeyRedux?.subActiveKey === 7.1 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                              {activeKeyRedux?.subActiveKey === 7.1 ? <Icon.CardHeading className="me-2" /> : <Icon.CardHeading className="me-2 icon" />} Japti Notice
                            </Button>
                            <Button onClick={() => { navigate("/dashboard/japti-karvai"); handleAccordionChange(7, 7.2, "Japti Karvai"); }} className={activeKeyRedux?.subActiveKey === 7.2 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                              {activeKeyRedux?.subActiveKey === 7.2 ? <Icon.Coin className="me-2" /> : <Icon.Coin className="me-2 icon" />} Japti Karvai
                            </Button>
                            <Button onClick={() => { navigate("/dashboard/japti-mukti"); handleAccordionChange(7, 7.3, "Japti Mukti"); }} className={activeKeyRedux?.subActiveKey === 7.3 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                              {activeKeyRedux?.subActiveKey === 7.3 ? <Icon.Coin className="me-2" /> : <Icon.Coin className="me-2 icon" />} Japti Mukti
                            </Button>
                            <Button onClick={() => { navigate("/dashboard/japti-karvai-zone-report"); handleAccordionChange(7, 7.4, "Japti Karvai Zone Report"); }} className={activeKeyRedux?.subActiveKey === 7.4 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                              {activeKeyRedux?.subActiveKey === 7.4 ? <Icon.Coin className="me-2" /> : <Icon.Coin className="me-2 icon" />} Karvai Zone Report
                            </Button>
                          </Accordion.Body>
                        </Accordion.Item>

                        {/* Update Mobile */}
                        <Accordion.Item eventKey="180" className={activeKeyRedux?.activeKey === 180 ? "activeMenu" : ""}>
                          <Accordion.Header onClick={() => { navigate("/dashboard/update-mobile"); handleAccordionChange(180, 180, "Update Mobile"); }}>
                            {activeKeyRedux?.subActiveKey === 180 ? <Icon.TelephoneFill className="me-2" /> : <Icon.Telephone className="me-2 icon" />}
                            Update Mobile
                          </Accordion.Header>
                        </Accordion.Item>

                        {financialYear !== "2023-2024" && (
                          <>
                            <Accordion.Item eventKey={19} className={activeKeyRedux.activeKey === 19 ? "activeMenu dropDown" : "dropDown"}>
                              <Accordion.Header onClick={() => { handleAccordionChange(19, activeKeyRedux.subActiveKey, activeKeyRedux.activeTab); }}>
                                {activeKeyRedux?.activeKey === 19 ? <Icon.Receipt className="me-2" /> : <Icon.Receipt className="me-2 icon" />}
                                Manage Bills
                              </Accordion.Header>
                              <Accordion.Body className="d-flex flex-column">
                                <Button onClick={() => { navigate("/dashboard/deleted-bill-history"); handleAccordionChange(19, 19.1, "Deleted Bill History"); }} className={activeKeyRedux?.subActiveKey === 19.1 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                                  {activeKeyRedux?.subActiveKey === 19.1 ? <Icon.ReceiptCutoff className="me-2" /> : <Icon.ReceiptCutoff className="me-2 icon" />} Deleted Bill History
                                </Button>
                              </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="20" className={activeKeyRedux?.activeKey === 20 ? "activeMenu" : ""}>
                              <Accordion.Header onClick={() => { handleAccordionChange(20, 20, "Rejected Bills"); navigate("/dashboard/rejected-list"); }}>
                                {activeKeyRedux?.activeKey === 20 ? <Icon.FileEarmarkExcelFill className="me-2" /> : <Icon.FileEarmarkExcel className="me-2 icon" />}
                                Rejected Bills
                              </Accordion.Header>
                            </Accordion.Item>
                          </>
                        )}

                        {financialYear === "2023-2024" && (
                          <>
                            <Accordion.Item eventKey={8} className={activeKeyRedux?.activeKey === 8 ? "activeMenu" : ""}>
                              <Accordion.Header onClick={() => { handleAccordionChange(8, 8, "SMS Sent Report"); navigate("/dashboard/sms-sent-report"); }}>
                                {activeKeyRedux?.activeKey === 8 ? <Icon.EnvelopeAtFill className="me-2" /> : <Icon.EnvelopeAt className="me-2 icon" />}
                                SMS Sent Report
                              </Accordion.Header>
                            </Accordion.Item>
                            <Accordion.Item eventKey={9} className={activeKeyRedux?.activeKey === 9 ? "activeMenu" : ""}>
                              <Accordion.Header onClick={() => { handleAccordionChange(9, 9, "SMS Details"); navigate("/dashboard/sms-details"); }}>
                                {activeKeyRedux?.activeKey === 9 ? <Icon.EnvelopeAtFill className="me-2" /> : <Icon.EnvelopeAt className="me-2 icon" />}
                                SMS Details
                              </Accordion.Header>
                            </Accordion.Item>
                            <Accordion.Item eventKey={10} className={activeKeyRedux?.activeKey === 10 ? "activeMenu" : ""}>
                              <Accordion.Header onClick={() => { handleAccordionChange(10, 10, "Analytics"); navigate("/dashboard/analytics"); }}>
                                {activeKeyRedux?.activeKey === 10 ? <Icon.BarChartFill className="me-2" /> : <Icon.BarChart className="me-2 icon" />}
                                Analytics
                              </Accordion.Header>
                            </Accordion.Item>
                          </>
                        )}

                        {financialYear !== "2023-2024" && financialYear !== "2024-2025" && (
                          <>
                            <Accordion.Item eventKey="44" className={activeKeyRedux.activeKey === 44 ? "activeMenu dropDown" : "dropDown"}>
                              <Accordion.Header onClick={() => { handleAccordionChange(44, activeKeyRedux.subActiveKey, activeKeyRedux.activeTab); }}>
                                {activeKeyRedux?.activeKey === 44 ? <Icon.ImageFill className="me-2" /> : <Icon.Images className="me-2 icon" />}
                                Verification
                              </Accordion.Header>
                              <Accordion.Body className="d-flex flex-column">
                                <Button onClick={() => { navigate("/dashboard/imageverification"); handleAccordionChange(44, 44.1, "Image Verification"); }} className={activeKeyRedux?.subActiveKey === 44.1 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                                  {activeKeyRedux?.subActiveKey === 44.1 ? <Icon.ShieldFillCheck className="me-2" /> : <Icon.ShieldCheck className="me-2 icon" />} Image Verification
                                </Button>
                                <Button onClick={() => { navigate("/dashboard/rejected"); handleAccordionChange(44, 44.2, "Image Verification History"); }} className={activeKeyRedux?.subActiveKey === 44.2 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                                  {activeKeyRedux?.subActiveKey === 44.2 ? <Icon.ImageFill className="me-2" /> : <Icon.Image className="me-2 icon" />} Image Verification History
                                </Button>
                                <Button onClick={() => { navigate("/dashboard/surveyverification"); handleAccordionChange(44, 44.3, "Survey Verification"); }} className={activeKeyRedux?.subActiveKey === 44.3 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                                  {activeKeyRedux?.subActiveKey === 44.3 ? <Icon.ShieldFillCheck className="me-2" /> : <Icon.ShieldCheck className="me-2 icon" />} Survey Verification
                                </Button>
                                <Button onClick={() => { navigate("/dashboard/surveyrejected"); handleAccordionChange(44, 44.4, "Survey Verification History"); }} className={activeKeyRedux?.subActiveKey === 44.4 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                                  {activeKeyRedux?.subActiveKey === 44.4 ? <Icon.ImageFill className="me-2" /> : <Icon.Image className="me-2 icon" />} Survey Verification History
                                </Button>
                              </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="45" className={activeKeyRedux?.activeKey === 45 ? "activeMenu" : ""}>
                              <Accordion.Header onClick={() => { handleAccordionChange(45, 45, "Palika User Wise Bill Watap Report"); navigate("/dashboard/palika-users"); }}>
                                {activeKeyRedux?.activeKey === 45 ? <Icon.PeopleFill className="me-2" /> : <Icon.People className="me-2 icon" />}
                                Palika User Wise Bill Watap Report
                              </Accordion.Header>
                            </Accordion.Item>
                          </>
                        )}

                        {userState?.usertype_keyname[0] === "internalDev" && (
                          <Accordion.Item eventKey="internalDev_7" className={activeKeyRedux.activeKey === 7 ? "activeMenu" : ""}>
                            <Accordion.Header onClick={() => { handleAccordionChange(7, 7.3, "Internal Developer"); navigate("/dashboard/internal-dev"); }}>
                              {activeKeyRedux.activeKey === 7 ? <Icon.DatabaseFillLock className="me-2" /> : <Icon.DatabaseLock className="me-2 icon" />}
                              Internal Dev
                            </Accordion.Header>
                          </Accordion.Item>
                        )}
                        {userState?.usertype_keyname[0] === "internalDev" && (
                          <Accordion.Item eventKey="21" className={activeKeyRedux.activeKey === 21 ? "activeMenu" : ""}>
                            <Accordion.Header onClick={() => { handleAccordionChange(21, 21, "Export Call Logs"); navigate("/dashboard/export-call-logs"); }}>
                              {activeKeyRedux.activeKey === 21 ? <Icon.TelephonePlusFill className="me-2" /> : <Icon.TelephonePlus className="me-2 icon" />}
                              Export Call Logs
                            </Accordion.Header>
                          </Accordion.Item>
                        )}
                        {userState?.usertype_keyname[0] === "internalDev" && (
                          <Accordion.Item eventKey="22" className={activeKeyRedux.activeKey === 22 ? "activeMenu" : ""}>
                            <Accordion.Header onClick={() => { handleAccordionChange(22, 22, "Import Telecalling"); navigate("/dashboard/telecalling-defaulter"); }}>
                              {activeKeyRedux.activeKey === 22 ? <Icon.ClockFill className="me-2" /> : <Icon.ClockHistory className="me-2 icon" />}
                              Telecalling Defaulter
                            </Accordion.Header>
                          </Accordion.Item>
                        )}
                        {userState?.usertype_keyname[0] === "internalDev" && (
                          <Accordion.Item eventKey="35" className={activeKeyRedux.activeKey === 35 ? "activeMenu" : ""}>
                            <Accordion.Header onClick={() => { handleAccordionChange(35, 35, "Export Call Logs"); navigate("/dashboard/export-call-logs"); }}>
                              {activeKeyRedux.activeKey === 35 ? <Icon.TelephonePlusFill className="me-2" /> : <Icon.TelephonePlus className="me-2 icon" />}
                              Export Call Logs
                            </Accordion.Header>
                          </Accordion.Item>
                        )}
                        {userState?.usertype_keyname[0] === "internalDev" && (
                          <Accordion.Item eventKey="36" className={activeKeyRedux.activeKey === 36 ? "activeMenu" : ""}>
                            <Accordion.Header onClick={() => { handleAccordionChange(36, 36, "Import Telecalling"); navigate("/dashboard/telecalling-defaulter"); }}>
                              {activeKeyRedux.activeKey === 36 ? <Icon.ClockFill className="me-2" /> : <Icon.ClockHistory className="me-2 icon" />}
                              Telecalling Defaulter
                            </Accordion.Header>
                          </Accordion.Item>
                        )}

                      </Accordion>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </>
            ) : ("")}

            {/* ===================== SUPERVISOR ===================== */}
            {userState.usertype_keyname[0] === "supervisor" ? (
              <Accordion flush>
                <Accordion.Item eventKey={0} className={activeKeyRedux.activeKey === 0 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(0, 0, "Home"); navigate("/dashboard"); }}>
                    {activeKeyRedux.activeKey === 0 ? <Icon.HouseDoorFill className="me-2" /> : <Icon.HouseDoor className="me-2 icon" />}
                    Home
                  </Accordion.Header>
                </Accordion.Item>
                <Accordion.Item eventKey={1} className={activeKeyRedux.activeKey === 1 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(1, 1, "Manage Roles"); navigate("/dashboard/manage-roles"); }}>
                    {activeKeyRedux.activeKey === 1 ? <Icon.PersonFillGear className="me-2" /> : <Icon.PersonGear className="me-2 icon" />}
                    Manage Users
                  </Accordion.Header>
                </Accordion.Item>
              </Accordion>
            ) : ("")}

            {/* ===================== ZONAL OFFICER ===================== */}
            {userState.usertype_keyname[0] === "zonalofficer" ? (
              <Accordion flush defaultActiveKey={activeKeyRedux?.activeKey}>

                <Accordion.Item eventKey={10} className={activeKeyRedux?.activeKey === 10 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(10, 10, "Bill Distribution"); navigate(financialYear === "2023-2024" ? "/dashboard/bill-distribution" : "/dashboard/new-home"); }}>
                    {activeKeyRedux?.activeKey === 10 ? <Icon.HouseDoorFill className="me-2" /> : <Icon.HouseDoor className="me-2 icon" />}
                    Bill Distribution
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item eventKey="11" className={activeKeyRedux?.activeKey === 11 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(11, 11, "Property Visit Report"); navigate("/dashboard/new-visit-reports"); }}>
                    {activeKeyRedux?.activeKey === 11 ? <Icon.PeopleFill className="me-2" /> : <Icon.People className="me-2 icon" />}
                    Property Visit Report
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item eventKey={112} className={activeKeyRedux?.activeKey === 112 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(112, 112, "Staff Visit Report"); navigate("/dashboard/staff-visit-reports"); }}>
                    {activeKeyRedux?.activeKey === 112 ? <Icon.PeopleFill className="me-2" /> : <Icon.People className="me-2 icon" />}
                    Staff Visit Report
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item eventKey="12" className={activeKeyRedux?.activeKey === 12 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(12, 12, "Mahila Wise Bill Watap Report"); navigate(financialYear === "2023-2024" ? "/dashboard/contractors" : "/dashboard/new-contractors"); }}>
                    {activeKeyRedux?.activeKey === 12 ? <Icon.PeopleFill className="me-2" /> : <Icon.People className="me-2 icon" />}
                    Mahila Wise Bill Watap Report
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item eventKey="13" className={activeKeyRedux?.activeKey === 13 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(13, 13, "Zone Wise Bill Analysis"); navigate(financialYear === "2023-2024" ? "/dashboard/zonewise-bill-analysis" : "/dashboard/new-bill-analysis"); }}>
                    {activeKeyRedux?.activeKey === 13 ? <Icon.Receipt className="me-2" /> : <Icon.Receipt className="me-2 icon" />}
                    Zone Wise Bill Analysis
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item eventKey="113" className={activeKeyRedux?.activeKey === 113 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(113, 113, "Gat Lipik Analysis"); navigate("/dashboard/gatlipik-report-analysis"); }}>
                    {activeKeyRedux?.activeKey === 113 ? <Icon.Receipt className="me-2" /> : <Icon.Receipt className="me-2 icon" />}
                    Gat Lipik Report Analysis
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item eventKey="18" className={activeKeyRedux?.activeKey === 18 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(18, 18, "Gatwise Bill Analysis"); navigate("/dashboard/gatwise-bill-analysis"); }}>
                    {activeKeyRedux?.activeKey === 18 ? <Icon.Receipt className="me-2" /> : <Icon.Receipt className="me-2 icon" />}
                    Gatwise Bill Analysis
                  </Accordion.Header>
                </Accordion.Item>

                {/* Telecalling - Zonal */}
                <Accordion.Item eventKey={311} className={activeKeyRedux.activeKey === 311 ? "activeMenu dropDown" : "dropDown"}>
                  <Accordion.Header onClick={() => { handleAccordionChange(311, activeKeyRedux.subActiveKey, activeKeyRedux.activeTab); }}>
                    {activeKeyRedux?.activeKey === 311 ? <Icon.PeopleFill className="me-2" /> : <Icon.People className="me-2 icon" />}
                    Manage Telecalling
                  </Accordion.Header>
                  <Accordion.Body className="d-flex flex-column">
                    <Button onClick={() => { navigate("/dashboard/zonal-call-summary"); handleAccordionChange(311, 311.1, "Call Summary"); }} className={activeKeyRedux?.subActiveKey === 311.1 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                      {activeKeyRedux?.subActiveKey === 311.1 ? <Icon.ChatTextFill className="me-2" /> : <Icon.ChatText className="me-2 icon" />} Calling Summary
                    </Button>
                    <Button onClick={() => { navigate("/dashboard/zonal-call-logs"); handleAccordionChange(311, 311.2, "Call Logs"); }} className={activeKeyRedux?.subActiveKey === 311.2 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                      {activeKeyRedux?.subActiveKey === 311.2 ? <Icon.TelephoneForwardFill className="me-2" /> : <Icon.TelephoneForward className="me-2 icon" />} Call Logs
                    </Button>
                    <Button onClick={() => { navigate("/dashboard/zonal-dialed-call-logs"); handleAccordionChange(311, 311.3, "Dialed Call Logs"); }} className={activeKeyRedux?.subActiveKey === 311.3 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                      {activeKeyRedux?.subActiveKey === 311.3 ? <Icon.TelephoneForwardFill className="me-2" /> : <Icon.TelephoneForward className="me-2 icon" />} Dialed Call Logs
                    </Button>
                    <Button onClick={() => { handleAccordionChange(311, 311.5, "Total Call Summary"); navigate("/dashboard/zonal-total-calling"); }} className={activeKeyRedux?.subActiveKey === 311.5 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                      {activeKeyRedux?.subActiveKey === 311.5 ? <Icon.TelephonePlusFill className="me-2" /> : <Icon.TelephonePlus className="me-2 icon" />} Total Call Summary
                    </Button>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="16" className={activeKeyRedux?.activeKey === 16 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(16, 16, "Japti Notice"); navigate("/dashboard/zonal-japti-notice"); }}>
                    {activeKeyRedux?.activeKey === 16 ? <Icon.CardHeading className="me-2" /> : <Icon.CardHeading className="me-2 icon" />}
                    Japti Notice
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item eventKey="22" className={activeKeyRedux?.activeKey === 22 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(22, 22, "Japti Karvai"); navigate("/dashboard/zonal-japti-karvai"); }}>
                    {activeKeyRedux?.activeKey === 22 ? <Icon.CardHeading className="me-2" /> : <Icon.CardHeading className="me-2 icon" />}
                    Japti Karvai
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item eventKey="23" className={activeKeyRedux?.activeKey === 23 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(23, 23, "Japti Mukti"); navigate("/dashboard/zonal-japti-mukti"); }}>
                    {activeKeyRedux?.activeKey === 23 ? <Icon.CardHeading className="me-2" /> : <Icon.CardHeading className="me-2 icon" />}
                    Japti Mukti
                  </Accordion.Header>
                </Accordion.Item>

                {/* Manage Bills - Zonal */}
                <Accordion.Item eventKey={15} className={activeKeyRedux.activeKey === 15 ? "activeMenu dropDown" : "dropDown"}>
                  <Accordion.Header onClick={() => { handleAccordionChange(15, activeKeyRedux.subActiveKey, activeKeyRedux.activeTab); }}>
                    {activeKeyRedux?.activeKey === 15 ? <Icon.Receipt className="me-2" /> : <Icon.Receipt className="me-2 icon" />}
                    Manage Bills
                  </Accordion.Header>
                  <Accordion.Body className="d-flex flex-column">
                    <Button onClick={() => { navigate("/dashboard/bill-report"); handleAccordionChange(15, 15.1, "Bill Report"); }} className={activeKeyRedux?.subActiveKey === 15.1 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                      {activeKeyRedux?.subActiveKey === 15.1 ? <Icon.ReceiptCutoff className="me-2" /> : <Icon.ReceiptCutoff className="me-2 icon" />} Bill Report
                    </Button>
                    <Button onClick={() => { navigate("/dashboard/deleted-bill-history"); handleAccordionChange(15, 15.2, "Deleted Bill History"); }} className={activeKeyRedux?.subActiveKey === 15.2 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                      {activeKeyRedux?.subActiveKey === 15.2 ? <Icon.ReceiptCutoff className="me-2" /> : <Icon.ReceiptCutoff className="me-2 icon" />} Deleted Bill History
                    </Button>
                  </Accordion.Body>
                </Accordion.Item>

                {/* Verification - Zonal */}
                <Accordion.Item eventKey="19" className={activeKeyRedux.activeKey === 19 ? "activeMenu dropDown" : "dropDown"}>
                  <Accordion.Header onClick={() => { handleAccordionChange(19, activeKeyRedux.subActiveKey, activeKeyRedux.activeTab); }}>
                    {activeKeyRedux?.activeKey === 19 ? <Icon.ImageFill className="me-2" /> : <Icon.Images className="me-2 icon" />}
                    Verification
                  </Accordion.Header>
                  <Accordion.Body className="d-flex flex-column">
                    <Button onClick={() => { navigate("/dashboard/imageverification"); handleAccordionChange(19, 19.1, "Image Verification"); }} className={activeKeyRedux?.subActiveKey === 19.1 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                      {activeKeyRedux?.subActiveKey === 19.1 ? <Icon.ShieldFillCheck className="me-2" /> : <Icon.ShieldCheck className="me-2 icon" />} Image Verification
                    </Button>
                    <Button onClick={() => { navigate("/dashboard/rejected"); handleAccordionChange(19, 19.2, "Image Verification History"); }} className={activeKeyRedux?.subActiveKey === 19.2 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                      {activeKeyRedux?.subActiveKey === 19.2 ? <Icon.ImageFill className="me-2" /> : <Icon.Image className="me-2 icon" />} Image Verification History
                    </Button>
                    <Button onClick={() => { navigate("/dashboard/surveyverification"); handleAccordionChange(19, 19.3, "Survey Verification"); }} className={activeKeyRedux?.subActiveKey === 19.3 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                      {activeKeyRedux?.subActiveKey === 19.3 ? <Icon.ShieldFillCheck className="me-2" /> : <Icon.ShieldCheck className="me-2 icon" />} Survey Verification
                    </Button>
                    <Button onClick={() => { navigate("/dashboard/surveyrejected"); handleAccordionChange(19, 19.4, "Survey Verification History"); }} className={activeKeyRedux?.subActiveKey === 19.4 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                      {activeKeyRedux?.subActiveKey === 19.4 ? <Icon.ImageFill className="me-2" /> : <Icon.Image className="me-2 icon" />} Survey Verification History
                    </Button>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="20" className={activeKeyRedux?.activeKey === 20 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(20, 20, "Palika User Wise Bill Watap Report"); navigate("/dashboard/palika-users"); }}>
                    {activeKeyRedux?.activeKey === 20 ? <Icon.PeopleFill className="me-2" /> : <Icon.People className="me-2 icon" />}
                    Palika User Wise Bill Watap Report
                  </Accordion.Header>
                </Accordion.Item>

              </Accordion>
            ) : ("")}

            {/* ===================== GAT LIPIK ===================== */}
            {userState.usertype_keyname[0] === "gatlipik" ? (
              <Accordion flush defaultActiveKey={activeKeyRedux?.activeKey}>

                <Accordion.Item eventKey={51} className={activeKeyRedux?.activeKey === 51 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(51, 51, "Bill Distribution"); navigate("/dashboard/new-gat-home"); }}>
                    {activeKeyRedux?.activeKey === 51 ? <Icon.HouseDoorFill className="me-2" /> : <Icon.HouseDoor className="me-2 icon" />}
                    Bill Distribution
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item eventKey={52} className={activeKeyRedux?.activeKey === 52 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(52, 52, "Property Visit Report"); navigate("/dashboard/gat-property-report"); }}>
                    {activeKeyRedux?.activeKey === 52 ? <Icon.PeopleFill className="me-2" /> : <Icon.People className="me-2 icon" />}
                    Property Visit Report
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item eventKey={53} className={activeKeyRedux?.activeKey === 53 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(53, 53, "Mahila Wise Bill Watap Report"); navigate("/dashboard/gat-mahila-report"); }}>
                    {activeKeyRedux?.activeKey === 53 ? <Icon.PeopleFill className="me-2" /> : <Icon.People className="me-2 icon" />}
                    Mahila Wise Bill Watap Report
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item eventKey={54} className={activeKeyRedux?.activeKey === 54 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(54, 54, "Gatwise Bill Analysis"); navigate("/dashboard/gat-wise-bill-analysis"); }}>
                    {activeKeyRedux?.activeKey === 54 ? <Icon.Receipt className="me-2" /> : <Icon.Receipt className="me-2 icon" />}
                    Gatwise Bill Analysis
                  </Accordion.Header>
                </Accordion.Item>

                {/* Telecalling - Gat */}
                <Accordion.Item eventKey={312} className={activeKeyRedux.activeKey === 312 ? "activeMenu dropDown" : "dropDown"}>
                  <Accordion.Header onClick={() => { handleAccordionChange(312, activeKeyRedux.subActiveKey, activeKeyRedux.activeTab); }}>
                    {activeKeyRedux?.activeKey === 312 ? <Icon.PeopleFill className="me-2" /> : <Icon.People className="me-2 icon" />}
                    Manage Telecalling
                  </Accordion.Header>
                  <Accordion.Body className="d-flex flex-column">
                    <Button onClick={() => { navigate("/dashboard/gat-call-summary"); handleAccordionChange(312, 312.1, "Call Summary"); }} className={activeKeyRedux?.subActiveKey === 312.1 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                      {activeKeyRedux?.subActiveKey === 312.1 ? <Icon.ChatTextFill className="me-2" /> : <Icon.ChatText className="me-2 icon" />} Calling Summary
                    </Button>
                    <Button onClick={() => { navigate("/dashboard/gat-call-logs"); handleAccordionChange(312, 312.2, "Call Logs"); }} className={activeKeyRedux?.subActiveKey === 312.2 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                      {activeKeyRedux?.subActiveKey === 312.2 ? <Icon.TelephoneForwardFill className="me-2" /> : <Icon.TelephoneForward className="me-2 icon" />} Call Logs
                    </Button>
                    <Button onClick={() => { navigate("/dashboard/gat-dialed-call-logs"); handleAccordionChange(312, 312.3, "Dialed Call Logs"); }} className={activeKeyRedux?.subActiveKey === 312.3 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                      {activeKeyRedux?.subActiveKey === 312.3 ? <Icon.TelephoneForwardFill className="me-2" /> : <Icon.TelephoneForward className="me-2 icon" />} Dialed Call Logs
                    </Button>
                    <Button onClick={() => { handleAccordionChange(312, 312.5, "Total Call Summary"); navigate("/dashboard/gat-total-calling"); }} className={activeKeyRedux?.subActiveKey === 312.5 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                      {activeKeyRedux?.subActiveKey === 312.5 ? <Icon.TelephonePlusFill className="me-2" /> : <Icon.TelephonePlus className="me-2 icon" />} Total Call Summary
                    </Button>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey={55} className={activeKeyRedux?.activeKey === 55 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(55, 55, "Japti Notice"); navigate("/dashboard/gat-japti-notice"); }}>
                    {activeKeyRedux?.activeKey === 55 ? <Icon.CardHeading className="me-2" /> : <Icon.CardHeading className="me-2 icon" />}
                    Japti Notice
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item eventKey={59} className={activeKeyRedux?.activeKey === 59 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(59, 59, "Japti Karwai"); navigate("/dashboard/gat-japti-karwai"); }}>
                    {activeKeyRedux?.activeKey === 59 ? <Icon.CardHeading className="me-2" /> : <Icon.CardHeading className="me-2 icon" />}
                    Japti Karwai
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item eventKey={60} className={activeKeyRedux?.activeKey === 60 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(60, 60, "Japti Mukti"); navigate("/dashboard/gat-japti-mukti"); }}>
                    {activeKeyRedux?.activeKey === 60 ? <Icon.CardHeading className="me-2" /> : <Icon.CardHeading className="me-2 icon" />}
                    Japti Mukti
                  </Accordion.Header>
                </Accordion.Item>

                {/* Manage Bills - Gat */}
                <Accordion.Item eventKey={56} className={activeKeyRedux.activeKey === 56 ? "activeMenu dropDown" : "dropDown"}>
                  <Accordion.Header onClick={() => { handleAccordionChange(56, activeKeyRedux.subActiveKey, activeKeyRedux.activeTab); }}>
                    {activeKeyRedux?.activeKey === 56 ? <Icon.Receipt className="me-2" /> : <Icon.Receipt className="me-2 icon" />}
                    Manage Bills
                  </Accordion.Header>
                  <Accordion.Body className="d-flex flex-column">
                    <Button onClick={() => { navigate("/dashboard/gat-bill-report"); handleAccordionChange(56, 56.1, "Bill Report"); }} className={activeKeyRedux?.subActiveKey === 56.1 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                      {activeKeyRedux?.subActiveKey === 56.1 ? <Icon.ReceiptCutoff className="me-2" /> : <Icon.ReceiptCutoff className="me-2 icon" />} Bill Report
                    </Button>
                    <Button onClick={() => { navigate("/dashboard/gat-deleted-bill-history"); handleAccordionChange(56, 56.2, "Deleted Bill History"); }} className={activeKeyRedux?.subActiveKey === 56.2 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                      {activeKeyRedux?.subActiveKey === 56.2 ? <Icon.ReceiptCutoff className="me-2" /> : <Icon.ReceiptCutoff className="me-2 icon" />} Deleted Bill History
                    </Button>
                  </Accordion.Body>
                </Accordion.Item>

                {/* Verification - Gat */}
                <Accordion.Item eventKey={57} className={activeKeyRedux.activeKey === 57 ? "activeMenu dropDown" : "dropDown"}>
                  <Accordion.Header onClick={() => { handleAccordionChange(57, activeKeyRedux.subActiveKey, activeKeyRedux.activeTab); }}>
                    {activeKeyRedux?.activeKey === 57 ? <Icon.ImageFill className="me-2" /> : <Icon.Images className="me-2 icon" />}
                    Verification
                  </Accordion.Header>
                  <Accordion.Body className="d-flex flex-column">
                    <Button onClick={() => { navigate("/dashboard/imageverification"); handleAccordionChange(57, 57.1, "Image Verification"); }} className={activeKeyRedux?.subActiveKey === 57.1 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                      {activeKeyRedux?.subActiveKey === 57.1 ? <Icon.ShieldFillCheck className="me-2" /> : <Icon.ShieldCheck className="me-2 icon" />} Image Verification
                    </Button>
                    <Button onClick={() => { navigate("/dashboard/rejected"); handleAccordionChange(57, 57.2, "Image Verification History"); }} className={activeKeyRedux?.subActiveKey === 57.2 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                      {activeKeyRedux?.subActiveKey === 57.2 ? <Icon.ImageFill className="me-2" /> : <Icon.Image className="me-2 icon" />} Image Verification History
                    </Button>
                    <Button onClick={() => { navigate("/dashboard/surveyverification"); handleAccordionChange(57, 57.3, "Survey Verification"); }} className={activeKeyRedux?.subActiveKey === 57.3 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                      {activeKeyRedux?.subActiveKey === 57.3 ? <Icon.ShieldFillCheck className="me-2" /> : <Icon.ShieldCheck className="me-2 icon" />} Survey Verification
                    </Button>
                    <Button onClick={() => { navigate("/dashboard/surveyrejected"); handleAccordionChange(57, 57.4, "Survey Verification History"); }} className={activeKeyRedux?.subActiveKey === 57.4 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                      {activeKeyRedux?.subActiveKey === 57.4 ? <Icon.ImageFill className="me-2" /> : <Icon.Image className="me-2 icon" />} Survey Verification History
                    </Button>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="58" className={activeKeyRedux?.activeKey === 58 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(58, 58, "Palika User Wise Bill Watap Report"); navigate("/dashboard/palika-users"); }}>
                    {activeKeyRedux?.activeKey === 58 ? <Icon.PeopleFill className="me-2" /> : <Icon.People className="me-2 icon" />}
                    Palika User Wise Bill Watap Report
                  </Accordion.Header>
                </Accordion.Item>

              </Accordion>
            ) : ("")}

            {/* ===================== MAVIM ===================== */}
            {userState.usertype_keyname[0] === "mavim" ? (
              <Accordion flush defaultActiveKey={activeKeyRedux?.activeKey}>

                <Accordion.Item eventKey={10} className={activeKeyRedux?.activeKey === 10 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(10, 10, "Bill Distribution"); navigate(financialYear === "2023-2024" ? "/dashboard/bill-distribution" : "/dashboard/new-home"); }}>
                    {activeKeyRedux?.activeKey === 10 ? <Icon.HouseDoorFill className="me-2" /> : <Icon.HouseDoor className="me-2 icon" />}
                    Bill Distribution
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item eventKey="11" className={activeKeyRedux?.activeKey === 11 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(11, 11, "Property Visit Report"); navigate("/dashboard/new-visit-reports"); }}>
                    {activeKeyRedux?.activeKey === 11 ? <Icon.PeopleFill className="me-2" /> : <Icon.People className="me-2 icon" />}
                    Property Visit Report
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item eventKey="12" className={activeKeyRedux?.activeKey === 12 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(12, 12, "Mahila Wise Bill Watap Report"); navigate(financialYear === "2023-2024" ? "/dashboard/contractors" : "/dashboard/new-contractors"); }}>
                    {activeKeyRedux?.activeKey === 12 ? <Icon.PeopleFill className="me-2" /> : <Icon.People className="me-2 icon" />}
                    Mahila Wise Bill Watap Report
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item eventKey="13" className={activeKeyRedux?.activeKey === 13 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(13, 13, "Zone Wise Bill Analysis"); navigate(financialYear === "2023-2024" ? "/dashboard/zonewise-bill-analysis" : "/dashboard/new-bill-analysis"); }}>
                    {activeKeyRedux?.activeKey === 13 ? <Icon.Receipt className="me-2" /> : <Icon.Receipt className="me-2 icon" />}
                    Zone Wise Bill Analysis
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item eventKey={15} className={activeKeyRedux.activeKey === 15 ? "activeMenu dropDown" : "dropDown"}>
                  <Accordion.Header onClick={() => { handleAccordionChange(15, activeKeyRedux.subActiveKey, activeKeyRedux.activeTab); }}>
                    {activeKeyRedux?.activeKey === 15 ? <Icon.Receipt className="me-2" /> : <Icon.Receipt className="me-2 icon" />}
                    Manage Bills
                  </Accordion.Header>
                  <Accordion.Body className="d-flex flex-column">
                    <Button onClick={() => { navigate("/dashboard/bill-report"); handleAccordionChange(15, 15.1, "Bill Report"); }} className={activeKeyRedux?.subActiveKey === 15.1 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                      {activeKeyRedux?.subActiveKey === 15.1 ? <Icon.ReceiptCutoff className="me-2" /> : <Icon.ReceiptCutoff className="me-2 icon" />} Bill Report
                    </Button>
                    <Button onClick={() => { navigate("/dashboard/deleted-bill-history"); handleAccordionChange(15, 15.2, "Deleted Bill History"); }} className={activeKeyRedux?.subActiveKey === 15.2 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                      {activeKeyRedux?.subActiveKey === 15.2 ? <Icon.ReceiptCutoff className="me-2" /> : <Icon.ReceiptCutoff className="me-2 icon" />} Deleted Bill History
                    </Button>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="17" className={activeKeyRedux?.activeKey === 17 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(17, 17, "Rejected Bills"); navigate("/dashboard/rejected-list"); }}>
                    {activeKeyRedux?.activeKey === 17 ? <Icon.FileEarmarkExcelFill className="me-2" /> : <Icon.FileEarmarkExcel className="me-2 icon" />}
                    Rejected Bills
                  </Accordion.Header>
                </Accordion.Item>

              </Accordion>
            ) : ("")}

            {/* ===================== SAKSHAMA ===================== */}
            {userState.usertype_keyname[0] === "sakshama" ? (
              <Accordion flush defaultActiveKey={activeKeyRedux?.activeKey}>

                <Accordion.Item eventKey={10} className={activeKeyRedux?.activeKey === 10 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(10, 10, "Bill Distribution"); navigate(financialYear === "2023-2024" ? "/dashboard/bill-distribution" : "/dashboard/new-home"); }}>
                    {activeKeyRedux?.activeKey === 10 ? <Icon.HouseDoorFill className="me-2" /> : <Icon.HouseDoor className="me-2 icon" />}
                    Bill Distribution
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item eventKey="11" className={activeKeyRedux?.activeKey === 11 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(11, 11, "Property Visit Report"); navigate("/dashboard/new-visit-reports"); }}>
                    {activeKeyRedux?.activeKey === 11 ? <Icon.PeopleFill className="me-2" /> : <Icon.People className="me-2 icon" />}
                    Property Visit Report
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item eventKey="12" className={activeKeyRedux?.activeKey === 12 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(12, 12, "Mahila Wise Bill Watap Report"); navigate(financialYear === "2023-2024" ? "/dashboard/contractors" : "/dashboard/new-contractors"); }}>
                    {activeKeyRedux?.activeKey === 12 ? <Icon.PeopleFill className="me-2" /> : <Icon.People className="me-2 icon" />}
                    Mahila Wise Bill Watap Report
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item eventKey="13" className={activeKeyRedux?.activeKey === 13 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(13, 13, "Zone Wise Bill Analysis"); navigate(financialYear === "2023-2024" ? "/dashboard/zonewise-bill-analysis" : "/dashboard/new-bill-analysis"); }}>
                    {activeKeyRedux?.activeKey === 13 ? <Icon.Receipt className="me-2" /> : <Icon.Receipt className="me-2 icon" />}
                    Zone Wise Bill Analysis
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item eventKey={15} className={activeKeyRedux.activeKey === 15 ? "activeMenu dropDown" : "dropDown"}>
                  <Accordion.Header onClick={() => { handleAccordionChange(15, activeKeyRedux.subActiveKey, activeKeyRedux.activeTab); }}>
                    {activeKeyRedux?.activeKey === 15 ? <Icon.Receipt className="me-2" /> : <Icon.Receipt className="me-2 icon" />}
                    Manage Bills
                  </Accordion.Header>
                  <Accordion.Body className="d-flex flex-column">
                    <Button onClick={() => { navigate("/dashboard/bill-report"); handleAccordionChange(15, 15.1, "Bill Report"); }} className={activeKeyRedux?.subActiveKey === 15.1 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                      {activeKeyRedux?.subActiveKey === 15.1 ? <Icon.ReceiptCutoff className="me-2" /> : <Icon.ReceiptCutoff className="me-2 icon" />} Bill Report
                    </Button>
                    <Button onClick={() => { navigate("/dashboard/deleted-bill-history"); handleAccordionChange(15, 15.2, "Deleted Bill History"); }} className={activeKeyRedux?.subActiveKey === 15.2 ? "accordionNavActive mb-3" : "accordionNav mb-3"}>
                      {activeKeyRedux?.subActiveKey === 15.2 ? <Icon.ReceiptCutoff className="me-2" /> : <Icon.ReceiptCutoff className="me-2 icon" />} Deleted Bill History
                    </Button>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="17" className={activeKeyRedux?.activeKey === 17 ? "activeMenu" : ""}>
                  <Accordion.Header onClick={() => { handleAccordionChange(17, 17, "Rejected Bills"); navigate("/dashboard/rejected-list"); }}>
                    {activeKeyRedux?.activeKey === 17 ? <Icon.FileEarmarkExcelFill className="me-2" /> : <Icon.FileEarmarkExcel className="me-2 icon" />}
                    Rejected Bills
                  </Accordion.Header>
                </Accordion.Item>

              </Accordion>
            ) : ("")}

          </div>
        </div>

        <div className="pb-4 ps-2">
          <Button className="btn-logout w-100" onClick={handleLogout}>
            {loader ? (
              <Spinner animation="border" variant="light" className="spinner" />
            ) : (
              <><Icon.BoxArrowLeft size={20} className="me-2" />Logout</>
            )}
          </Button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;